// Full course catalog data, sourced from "Upskill Course Descriptions.pdf".
// `value` matches the slug used in the training_course/training_course_2 select
// options in upskill-bahamas.js where that course already appears there.
const UPSKILL_BAHAMAS_COURSES_SUMMARY = [
  {
    value: 'building ai agents for beginners',
    title: 'Building AI Agents for Beginners (Beginner Level)',
    provider: 'Davidson College',
    description: 'A practical, no-code path to using AI agents effectively at work. Participants progress from prompting powerful AI models like a power user, to building automated workflows, connecting AI to third-party tools, and running autonomous agents on their own computer. Hands-on demonstrations and real professional scenarios build both technical fluency and an experimental mindset.',
    length: '30 hours',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'agentic ai developing ai agents (advanced)',
    title: 'Agentic AI: Developing AI Agents (Advanced Level)',
    provider: 'IBM',
    description: "An advanced program on building AI agents that think, reason, and take action using LangChain's tool calling and agent frameworks. Participants learn to connect large language models (LLMs) with external tools such as calculators, APIs, and data sources to extend model capabilities beyond text generation. Hands-on labs cover LangChain Expression Language, orchestrating tool calls, and pre-built DataFrame and SQL agents for data analysis.",
    length: '30 hours',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'no code automatization',
    title: 'No-Code & Automatization',
    provider: '4Geeks',
    description: "Learn to create useful apps and automated workflows without writing traditional code. The course introduces no-code tools to design simple websites and landing pages, scrape data, and build automated content and email workflows. You'll learn to connect services, trigger actions, and streamline business tasks even with no programming background.",
    length: '30 hours',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Professional Certification',
  },
  {
    value: 'foundations of ai digital skills',
    title: 'Foundations of AI & Digital Skills',
    provider: 'Beyond Code Collective',
    description: 'A beginner-friendly introduction to how AI works, where it shows up in everyday life, and how to use popular AI tools safely and effectively. Topics include digital platforms, AI writing and image tools, misinformation, online safety, no-code AI, prompt design, ethics, and career pathways in tech. Includes 4 hours of live, instructor-led online sessions.',
    length: '24 hours (4 hours live, 20 hours self-paced)',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'artificial intelligence an introduction & related topics',
    title: 'Artificial Intelligence: An Introduction & Related Topics',
    provider: 'Oxford University',
    description: 'This course consists of 2 sub-courses. The first, "Working with Artificial Intelligence: An Introduction," is run by leading Oxford AI Professor Michael Wooldridge and covers AI\'s historical development, theoretical foundations, modern applications, and ethical implications. For the second, students choose any of 14 complementary Oxford University courses.',
    length: '50 hours, made up of 2 sub-courses of approximately 25 hours each',
    requirement: 'Laptop/tablet recommended; mobile use allowed but not recommended.',
    receives: 'Two digital certificates of completion, corresponding to the two sub-courses',
  },
  {
    value: 'artificial intelligence practical applications & related topics',
    title: 'Artificial Intelligence: Practical Applications & Related Topics',
    provider: 'Oxford University',
    description: 'This course consists of 2 sub-courses. The first, "Working with Artificial Intelligence: Practical Applications," is run by leading Oxford AI Professor Michael Wooldridge and covers core AI topics, including common applications such as writing, brainstorming, research, and agentic AI. For the second, students choose any of 14 complementary Oxford University courses.',
    length: '50 hours, made up of 2 sub-courses of approximately 25 hours each',
    requirement: 'Laptop/tablet recommended; mobile use allowed but not recommended.',
    receives: 'Two digital certificates of completion, corresponding to the two sub-courses',
  },
  {
    value: 'artificial intelligence for everyone',
    title: 'Artificial Intelligence for Everyone',
    provider: 'Ply',
    description: "Understand what AI is, how it works, and how to apply it confidently in real work scenarios. The program moves from core concepts and real-world examples into hands-on practice with generative AI tools, then to designing simple no-code automations and agents. You'll learn to spot AI opportunities in your role and measure the impact of what you build.",
    length: '40 hours',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'data literacy',
    title: 'Data Literacy',
    provider: 'Le Wagon',
    description: "Learn the fundamentals of data and how it shapes decisions across health, education, economy, and security. This hands-on course teaches what data is, how it's stored in databases, how to extract it using SQL, and how to analyze it with Python. It also explores core AI concepts, including machine learning and deep learning, through real-world applications.",
    length: '40 hours',
    requirement: 'Laptop required; mobile use not supported.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'power bi sql for data analysts',
    title: 'Power BI and SQL for Data Analysts',
    provider: 'SkillNest',
    description: "Learn to query databases with SQL and build interactive Power BI dashboards that turn raw data into decision-ready information. The course covers managing and cleaning data, writing SQL queries, and designing visuals, filters, and measures. You'll structure dashboards that support real-world needs in finance, logistics, government, and other data-driven environments.",
    length: '30 hours',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'artificial intelligence in professional settings',
    title: 'Artificial Intelligence in Professional Settings: Practical Applications',
    provider: '4Geeks',
    description: "Transform everyday work by using AI tools like ChatGPT to research faster, automate repetitive tasks, and improve output quality. The course focuses on real workplace scenarios: drafting emails, summarizing documents, building reports, brainstorming, and working with basic data. You'll also learn good prompt design and safe, responsible AI use.",
    length: '30 hours',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'python for data analysts',
    title: 'Python for Data Analysts',
    provider: 'SkillNest',
    description: "Learn to manipulate, clean, and analyze data in Python using industry-standard tools like pandas and NumPy. The course covers core programming concepts, exploratory analysis, visualizations, and automating routine tasks with practical business and public-sector datasets. It builds a foundation for roles such as Data Analyst, Junior Data Scientist, or Business Intelligence Assistant.",
    length: '30 hours',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'basic web development',
    title: 'Basic Web Development',
    provider: 'SkillNest',
    description: "A hands-on introduction to building modern websites and digital interfaces using HTML, CSS, and JavaScript. You'll learn how web pages are structured, styled, and made interactive through practical exercises. The course develops skills for entry-level roles such as Front-End Developer, Web Content Manager, or Digital Product Assistant.",
    length: '30 hours',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'network fundamentals',
    title: 'Network Fundamentals',
    provider: '4Geeks',
    description: "Build a solid foundation in computer networking: topologies, IP addressing, Wi-Fi and LAN basics, troubleshooting, and essential security measures like VLANs and access control lists. You'll practice in realistic labs that mirror professional environments. The course prepares you for roles in IT support, infrastructure, and entry-level cybersecurity.",
    length: '30 hours',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Professional Certification',
  },
  {
    value: 'programming fundamentals languages and software development',
    title: 'Programming Fundamentals: Languages and Software Development',
    provider: '4Geeks',
    description: "Gain the core programming skills shared across modern languages: variables, data types, control flow, functions, basic algorithms, and working with Git and GitHub. By building small projects and solving structured problems, you'll learn to read, write, and debug simple programs with confidence. The course develops the foundation for careers in IT, software, and automation.",
    length: '30 hours',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Professional Certification',
  },
  {
    value: 'web development & creative coding',
    title: 'Web Development & Creative Coding',
    provider: '4Geeks',
    description: "Combine front-end web development with creative coding to build digital experiences that are both functional and visually engaging. The course covers HTML, CSS, and JavaScript for responsive websites, then introduces interactive interfaces and artistic coding techniques. You'll practice building pages, working with APIs and the DOM, and creating visual effects for a portfolio.",
    length: '30 hours',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Professional Certification',
  },
  {
    value: 'introduction to python programming',
    title: 'Introduction to Python Programming',
    provider: 'VisionAid Training',
    description: 'An accessible, beginner-friendly introduction to Python designed specifically for students with visual impairments, with full NVDA screen reader support. Learners go from installing Python and VS Code to writing, running, and debugging programs, covering variables, conditionals, loops, strings, lists, and functions. Self-paced modules are combined with weekly live mentor support and a simple final project.',
    length: '20–25 hours',
    requirement: 'Laptop required; mobile use not supported. Requires Python, VS Code, and the NVDA screen reader.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'personal finance professional certificate',
    title: 'Personal Finance Professional Certificate',
    provider: 'Indiana University ~ Kelley School of Business',
    description: "An accessible path into personal financial planning, covering budgeting, cash flow management, income statements, personal balance sheets, tax planning, and financial goal setting. The program addresses credit literacy in depth, including the five C's of credit and how to improve your credit score. A final module develops an investment mindset with risk tolerance, insurance comparison, and retirement income planning.",
    length: '120 hours',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'visual design',
    title: 'Visual Design',
    provider: 'Skillcrush',
    description: "Takes learners from foundational design principles to a polished, job-ready portfolio. Participants master visual hierarchy, color theory, and typography while building fluency in Figma, Photoshop, Illustrator, and InDesign, plus UI and web design and brand identity systems. Blends self-paced learning with live instructor support and closes with a capstone portfolio project.",
    length: '96–120 hours (about 3–6 months at 8–10 hours per week)',
    requirement: 'Computer with admin permissions to run Adobe Creative Cloud and Figma. Chromebooks, tablets, and phones are not compatible.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'ux design',
    title: 'UX Design',
    provider: 'Skillcrush',
    description: "Guides participants through the full product design process, from user research to a job-ready portfolio of real case studies. Learners run interviews, build sitemaps and user flows, create wireframes and interactive prototypes in Figma, and plan and run usability tests. Blends self-paced learning with live instructor support.",
    length: '96–120 hours (about 3–6 months at 8–10 hours per week)',
    requirement: 'Computer with admin permissions to run Adobe Creative Cloud and Figma. Chromebooks, tablets, and phones are not compatible.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'small business management certificate',
    title: 'Small Business Management Certificate',
    provider: 'Louisiana State University',
    description: "Explores the technical and essential skills needed to run a successful small business. Participants learn fundamental accounting, preparing the four major financial statements, social media and content marketing, and human resource management. Additional modules cover business planning, legal issues, customer care, and project management fundamentals.",
    length: '30 hours',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'finance & investment foundations',
    title: 'Finance & Investment Foundations',
    provider: 'Oxford University',
    description: 'A rigorous introduction to classical finance theory and behavioral finance, and to how financial and private markets function. Participants master core valuation concepts including the time value of money, NPV, and IRR, and explore venture finance and real estate investment. Participants complete a minimum of two modules from five options.',
    length: '32–48 hours (12 weeks at about 4 hours per week)',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'sustainability foundations',
    title: 'Sustainability Foundations',
    provider: 'Oxford University',
    description: 'Equips leaders to create sustainable value by balancing shareholder value and stakeholder engagement, and embedding sustainability into profit and purpose. Participants learn to act on the climate crisis through systemic thinking and explore what makes a just net-zero transition possible, plus how societies move from poverty to prosperity. Participants complete a minimum of two modules from three options.',
    length: '32–48 hours (12 weeks at about 4 hours per week)',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'introduction to investment banking',
    title: 'Introduction to Investment Banking',
    provider: 'The New York Institute of Finance',
    description: "A practical introduction to how investment banks and global financial markets work, taught by instructors with decades of Wall Street experience. Across six courses you'll cover determinants of value, foundations of financial markets, capital budgeting, risk management, credit principles, and mergers and acquisitions. The program concludes with a professional certificate exam.",
    length: '52 hours',
    requirement: 'Laptop required; mobile use not supported.',
    receives: 'Professional Certification from the New York Institute of Finance',
  },
  {
    value: 'how to maximize chances of quality employment',
    title: 'How to Maximize Chances of Quality Employment',
    provider: '4Geeks',
    description: "Boost your employability by building a strong, professional online presence that attracts recruiters and clients. You'll craft an impactful LinkedIn profile, develop a clear personal brand, and use digital channels strategically to expand your network. The course includes AI-supported job search and interview preparation tactics.",
    length: '30 hours',
    requirement: 'Laptop required; mobile use not supported.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'business communication',
    title: 'Business Communication',
    provider: 'Rochester Institute of Technology',
    description: 'Learn to use language and nonverbal communication to convey shared meanings in face-to-face and remote professional relationships. There is a strong focus on business writing, active listening, and articulating ideas effectively to diverse audiences. Learners apply their knowledge by critiquing real-world business scenarios.',
    length: '18 hours',
    requirement: 'Laptop required; mobile use not supported.',
    receives: 'Professional Certification',
  },
  {
    value: 'business finance',
    title: 'Business Finance',
    provider: 'W Learning',
    description: "Equips small business owners, managers, and aspiring entrepreneurs with the essential financial knowledge to build a profitable venture. You'll learn accounting principles, how to interpret the main financial statements, effective budgeting, and cash flow management. The course also shows how to use financial information strategically for pricing, cost control, and growth decisions, with no finance background required.",
    length: '20 hours',
    requirement: 'Laptop/tablet optional; course is mobile-friendly. A larger screen makes the examples and figures easier to see.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'introduction to corporate finance',
    title: 'Introduction to Corporate Finance',
    provider: 'Columbia University',
    description: 'Gain an understanding of time-honored financial concepts and how to apply them to value firms, bonds, and stocks. The course covers the time value of money, cost of capital, and capital budgeting, using Excel for valuations, NPV, and IRR. It is the introductory finance course required for all first-year MBA students at Columbia Business School.',
    length: '16 hours',
    requirement: 'Laptop required; mobile use not supported.',
    receives: 'Professional Certification',
  },
  {
    value: 'how to govern a company',
    title: 'How to Govern a Company',
    provider: 'The Association of Governance Risk & Compliance',
    description: 'A practical, up-to-date understanding of how modern organizations are governed. The certificate explores board roles and responsibilities, regulatory frameworks, internal control systems including the "Three Lines of Defense," and how ESG and sustainability shape today\'s governance agenda. Real-world examples show how to strengthen oversight and board effectiveness.',
    length: '20 hours',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Professional Certification',
  },
  {
    value: 'marketing fundamentals',
    title: 'Marketing Fundamentals',
    provider: 'Babson College',
    description: "Learn how to find the right customers and grow your business using core marketing fundamentals. The course shows how to use segmentation, targeting, and positioning, apply the marketing mix, and understand consumer behavior to create real value. You'll build a practical toolkit especially suited to entrepreneurial and small-business settings.",
    length: '24 hours',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Professional Certification',
  },
  {
    value: 'digital marketing online advertising social media',
    title: 'Digital Marketing, Online Advertising & Social Media',
    provider: 'University of Maryland',
    description: 'Learn to design effective online advertising ecosystems that combine paid media, social media, and big data analysis. The course covers evaluating display campaigns, analyzing reviews and sentiment, and applying social network analysis. Topics include SEO, influencers, landing pages, lead generation, click-through rates, email marketing, and content marketing.',
    length: '16 hours',
    requirement: 'Laptop required; mobile use not supported.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'business and data analysis skills',
    title: 'Business and Data Analysis Skills',
    provider: 'Fullbridge',
    description: "Learn to use a spreadsheet application like Microsoft Excel as a powerful analytical and communication tool. You'll perform real-world market and financial analyses and practice presenting findings visually for maximum impact. By the end, you'll be able to make data-driven decisions that help your organization grow.",
    length: '12 hours',
    requirement: 'Laptop required; mobile use not supported. A spreadsheet application (such as Microsoft Excel) is used throughout the course.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'entrepreneurship foundations',
    title: 'Entrepreneurship Foundations',
    provider: 'Oxford University',
    description: 'Gives participants a clear understanding of how entrepreneurial ideas take shape. Learners explore marketing psychology and consumer behavior, craft a solid organizational strategy, and examine innovation systems and their principles. Participants complete a minimum of two modules from four options.',
    length: '32–48 hours (12 weeks at about 4 hours per week)',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'ai for entrepreneurs',
    title: 'AI for Entrepreneurs',
    provider: 'Le Wagon',
    description: 'An immersive program for entrepreneurs who want to turn ideas into sustainable, competitive ventures. Participants explore the Business Model Canvas, strategic management, exponential technologies, data analysis, low-code/no-code tools, AI, and Agile methodologies. Strong emphasis is placed on UX/UI design, real-world cases, and networking with peers and industry experts.',
    length: '40 hours',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'entrepreneurial leadership toolbox',
    title: 'Entrepreneurial Leadership Toolbox',
    provider: 'Babson College',
    description: "Discover how to generate positive results by combining core leadership skills with an entrepreneurial mindset. You'll reframe leadership through an opportunity-focused lens and learn to move ideas forward even when not everything is known. The course provides practical tools for mobilizing teams, creating value, and leading change in fast-moving environments.",
    length: '30 hours',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'customer centric marketing for entrepreneurs',
    title: 'Customer-Centric Marketing for Entrepreneurs',
    provider: 'Babson College',
    description: "Gain practical experience by designing a customer-centric marketing campaign for your own business or for an organization that needs marketing support. You'll learn to build customer profiles and personas, choose the right marketing channels, and develop content and messaging that addresses real consumer needs and builds brand excitement. The course also covers KPIs, metrics, and milestones to measure your campaign's success.",
    length: '30 hours',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'ultimate massage therapist',
    title: 'Ultimate Massage Therapist',
    provider: 'Elizabeth Sands Beauty School',
    description: "Build hands-on bodywork expertise by combining full body Swedish massage with the restorative practice of Indian Head Massage. You'll learn to plan and adapt treatments safely, carry out thorough consultations, and work confidently with oils and massage mediums. The course maintains professional standards in line with health, safety, and hygiene requirements for spa, salon, and hospitality settings.",
    length: '25 hours',
    requirement: 'Laptop required; mobile use not supported.',
    receives: 'Professional Certification (fully accredited and internationally recognized)',
  },
  {
    value: 'nail technician course',
    title: 'Nail Technician Course',
    provider: 'Elizabeth Sands Beauty School',
    description: 'Gain comprehensive skills in professional nail care, from natural nail preparation to advanced enhancement and finishing techniques, covering both acrylic and gel. The course builds a strong technical foundation, product chemistry knowledge, and safe, tailored client service.',
    length: '25 hours',
    requirement: 'Laptop required; mobile use not supported.',
    receives: 'Professional Certification (fully accredited and internationally recognized)',
  },
  {
    value: 'ultimate first aid cpr and aed course for work home and leisure',
    title: 'Ultimate First Aid: CPR and AED Course for Work, Home and Leisure',
    provider: 'Online First Aid',
    description: 'Gain the skills and confidence to help yourself, family, and friends in a medical emergency. The course covers adult, baby, and child CPR and AED use, the recovery position, choking, heart attack, stroke, burns, drowning, head and spinal injuries, bleeding, and more. Clear step-by-step instructions, videos, infographics, and self-test sections work on all devices.',
    length: '20–25 hours',
    requirement: 'Laptop/tablet optional; course is mobile-friendly and compatible with all devices.',
    receives: 'UK HSE Appointed Person First Aid Qualification and verifiable CPD',
  },
  {
    value: 'customer service and professional communications',
    title: 'Customer Service and Professional Communications',
    provider: 'Turiscool',
    description: 'Comprehensive, practical training in customer service and professional communication for hospitality and tourism environments. Participants develop the strategic, interpersonal, and emotional skills to provide exceptional guest experiences across all service touchpoints, from bookings and reception to specialized guest services. The program builds skills in mindfulness, assertiveness, non-verbal communication, and conflict resolution through real-world case studies.',
    length: '25 hours',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'event planning',
    title: 'Event Planning',
    provider: 'W Learning',
    description: "Master the essentials of planning and managing successful events. You'll learn practical skills in logistics, budgeting, coordination, and marketing to run smooth, memorable events, from weddings and conferences to festivals and corporate functions. Practical insights prepare you to handle every detail and leave a lasting impression.",
    length: '20 hours',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'managing sustainable tourism experiences',
    title: 'Managing Sustainable Tourism Experiences',
    provider: 'W Learning',
    description: 'Learn to create positive visitor experiences, communicate effectively with diverse tourists, and provide excellent customer service. The course covers sustainable tourism practices that support local communities, culture, and environmental stewardship. It emphasizes practical skills and hands-on assignments you can apply directly in tourism and hospitality settings.',
    length: '20 hours',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'housekeeping management',
    title: 'Housekeeping Management',
    provider: 'TurisCool',
    description: "Learn how to run housekeeping as the backbone of a successful hotel or accommodation. The course covers room and public-area cleaning standards, correct use of tools and equipment, ergonomics, safe-work practices, and customer service from the housekeeping department. For supervisory roles, it also explores the Executive Housekeeper's responsibilities: planning, scheduling, cost control, and team leadership.",
    length: '20 hours',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'guest experience journey in hospitality',
    title: 'Guest Experience Journey in Hospitality',
    provider: 'W Learning',
    description: "Explore the guest journey and learn to provide exceptional hospitality at every touchpoint, from first booking to post-stay feedback. The course shows how small actions and thoughtful interactions turn an ordinary stay into an unforgettable experience. You'll learn to anticipate guest needs, solve problems efficiently, and create lasting impressions.",
    length: '20 hours',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'cruise ship hospitality fundamentals',
    title: 'Cruise Ship Hospitality Fundamentals',
    provider: 'W Learning',
    description: 'A beginner-friendly guide to the world of cruise ship careers. Learn how cruise operations run, the variety of jobs available, and what it takes to thrive on board. The course explores onboard culture, daily routines, and life at sea so you can decide whether a cruising career is right for you.',
    length: '20 hours',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'buffet management keys to service optimization',
    title: 'Buffet Management: Keys to Service Optimization',
    provider: 'Turiscool',
    description: "Learn how to plan and run buffet service that looks professional, flows smoothly, and controls waste. The course covers layout design to avoid bottlenecks, coordination with kitchen staff, portioning and replenishment strategies, and food-safety considerations. You'll also learn to make displays visually appealing while keeping operations efficient and profitable.",
    length: '15 hours',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'front desk operations and guest services',
    title: 'Front Desk Operations and Guest Services',
    provider: 'TurisCool',
    description: "Essential training for hotel professionals responsible for reception, concierge, bell services, and guest experience. The program covers check-in and check-out procedures, guest communication, problem-solving, service personalization, and coordination with other hotel departments. You'll be equipped to provide smooth, high-quality service at every guest touchpoint.",
    length: '15 hours',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'leadership foundations',
    title: 'Leadership Foundations',
    provider: 'Oxford University',
    description: "Strengthens leadership skills with a focus on motivation, adaptability, diversity, and influence. Participants learn to lead strategic projects in fast-changing, uncertain environments, lead with clarity during disruption, and respond to evolving client demands, with a dedicated module on women's leadership. Participants complete a minimum of two modules from five options.",
    length: '32–48 hours (12 weeks at about 4 hours per week)',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'the art of persuasive writing and public speaking',
    title: 'The Art of Persuasive Writing and Public Speaking',
    provider: 'Harvard University',
    description: 'Built around Harvard Professor James Engell\'s on-campus course "Elements of Rhetoric," this course helps you analyze and apply rhetorical structure and style. You\'ll learn how to persuade and how to recognize when someone is trying to persuade you. The newest edition includes persuasive speech in social media and the impact of generative AI on rhetoric.',
    length: '24 hours',
    requirement: 'Laptop required; mobile use not supported.',
    receives: 'Professional Certification',
  },
  {
    value: 'english for business pitching persuading and promoting',
    title: 'English for Business: Pitching, Persuading and Promoting',
    provider: 'Arizona State University',
    description: "Strengthen your business English so you can pitch ideas, persuade stakeholders, and promote products or services with confidence. You'll practice structuring compelling pitches, framing persuasive arguments, and choosing the right words and tone for meetings, presentations, and sales conversations. Designed for professionals and emerging leaders who use English at work.",
    length: '60 hours',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Professional Certification',
  },
  {
    value: 'spanish language level 1',
    title: 'Spanish Language Level 1',
    provider: 'Rocket Languages',
    description: "Start speaking real-life Spanish with a course that takes you from beginner to a confident conversational level in Latin American Spanish. Interactive audio lessons, speaking practice with voice recognition, and clear explanations build all four skills: listening, speaking, reading, and writing. Real-world role plays and cultural insights help you start thinking confidently in Spanish.",
    length: '120 hours',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'french language level 1',
    title: 'French Language Level 1',
    provider: 'Rocket Languages',
    description: "Start speaking real-life French with a course that takes you from beginner to a confident conversational level. Interactive audio lessons, speaking practice with voice recognition, and clear explanations build all four skills: listening, speaking, reading, and writing. Step-by-step lessons, role plays, and review activities help you overcome the fear of speaking.",
    length: '120 hours',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'ai for educators',
    title: 'AI for Educators',
    provider: 'SkillNest',
    description: 'Learn how AI enhances your teaching practice by helping you design lessons, create materials, support students, and manage tasks more efficiently. The course develops ethical, pedagogical, and practical skills for integrating AI into real classroom scenarios. Ready-to-apply workflows and educator-friendly tools help you personalize learning and save time.',
    length: '32 hours',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'classroom management for new teachers',
    title: 'Classroom Management for New Teachers',
    provider: 'W Learning',
    description: 'Build evidence-based classroom management skills designed specifically for early-career teachers. The course focuses on practical routines to organize your classroom, set clear expectations, and use positive, consistent behavior systems. It also covers proven engagement techniques and classroom-ready tools you can implement immediately.',
    length: '15 hours',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'teaching english as a foreign language (tefl)',
    title: 'Teaching English as a Foreign Language (TEFL)',
    provider: 'Cudoo',
    description: 'An accredited, fully online TEFL course with core principles, modern methodologies, and practical tools to teach English to non-native speakers. It guides you through lesson planning, classroom management, and teaching grammar, pronunciation, vocabulary, and all four language skills, including virtual and online teaching. The CPD-accredited certificate opens doors to international and remote teaching opportunities.',
    length: '120 hours',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Professional Certification',
  },
  {
    value: 'ai and special education',
    title: 'AI and Special Education',
    provider: 'CPD Classes',
    description: 'Explore how artificial intelligence can support more inclusive, effective special education practice. Educators learn core AI concepts and practical tools such as assistive technologies, adaptive learning platforms, and AI-enabled planning supports, and how to integrate them into Individualized Education Programs (IEPs), classroom routines, and differentiated instruction. The course emphasizes ethical and equitable use of AI grounded in inclusive education principles.',
    length: '45 hours',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'introduction to port management and terminal operations (beginner)',
    title: 'Introduction to Port Management and Terminal Operations (Beginner Level)',
    provider: "Lloyd's Maritime Institute",
    description: 'An introductory program covering the core pillars of maritime transport, commercial management, and logistics. Designed for participants with no prior industry experience who want a strong foundation in maritime and port logistics. It serves as a natural first step before progressing to more advanced port logistics programs.',
    length: '52 hours',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'warehouse operations management (intermediate)',
    title: 'Warehouse Operations Management (Intermediate Level)',
    provider: 'STC Next',
    description: "Covers the main activities inside a warehouse, from receiving, put-away, and storage to order picking, packaging, and shipping, and the warehouse's growing role in supply chains and e-commerce. You'll learn how to manage inventory, forecast stock-keeping capacity, and use IT and automation to keep operations reliable, efficient, and profitable. Suitable for middle and higher management.",
    length: '30 hours',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'port operations and maintenance training (intermediate/advanced)',
    title: 'Port Operations and Maintenance Training (Intermediate/Advanced Level)',
    provider: 'ASCE',
    description: 'A comprehensive, hands-on approach to the design, operation, and maintenance of port facilities. Participants develop expertise in inspection and repair of in-water, topside, and backlands infrastructure, plus asset management, GIS and financial tools, procurement, and design documents. Structural modules cover concrete, steel, timber, composite, and masonry structures, as well as fender and mooring systems.',
    length: '48–72 hours (normally done over 12 weeks with 4–6 hours per week)',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Certificate of Completion (2.4 CEUs / 24 PDHs)',
  },
  {
    value: 'caregiver certification course',
    title: 'Caregiver Certification Course',
    provider: 'U.S. Career Institute',
    description: "Prepares you for entry-level caregiver roles where compassion and professionalism go hand in hand. You'll learn infection prevention, basic first aid, accurate communication and documentation, and how to assist with daily living tasks such as bathing, grooming, dressing, and feeding. The course also covers vital signs, safe mobility and transfers, nutrition, and legal and ethical concepts like confidentiality and patient rights.",
    length: '90–95 hours',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: "Certificate of Completion, with eligibility for national certification through U.S. Career Institute's certification pathways",
  },
  {
    value: 'construction management',
    title: 'Construction Management',
    provider: 'University of Maryland',
    description: "Learn to manage construction projects with the skills of a modern Construction Manager. The program covers the knowledge, skills, tools, and techniques required to complete a project successfully. You'll learn to work effectively with owners, designers, developers, government agencies, contractors, lawyers, insurers, and other stakeholders.",
    length: '64 hours',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Professional Certification',
  },
  {
    value: 'autocad training',
    title: 'AutoCAD Training',
    provider: 'CAD Training Online',
    description: 'Master the essentials of AutoCAD drafting and design, from setting up drawings and applying precision tools like object snaps and layers to producing clean output for real-world projects.',
    length: '60 hours',
    requirement: 'A Windows 10 or Windows 11 PC capable of running the version of AutoCAD you want to learn. Mobile use is not supported.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'supply chain management tools and techniques',
    title: 'Supply Chain Management Tools and Techniques',
    provider: 'International Supply Chain Education Alliance',
    description: 'Provides a broad set of tools currently used in industry to make supply chains efficient and competitive. From the operations perspective, it introduces Sales Order Fulfillment and Aggregate Planning, along with planning strategies to produce what the market demands. The course prepares you for the ISCEA Certified Supply Chain Analyst (CSCA) exam and is a requirement for ISCEA certification.',
    length: '32 hours',
    requirement: 'Laptop required; mobile use not supported.',
    receives: 'Certificate of Completion',
  },
  {
    value: 'agribusiness value chains program',
    title: 'Agribusiness Value Chains Program',
    provider: 'Agribusiness Academy',
    description: "Gain a comprehensive understanding of the entire agribusiness value chain, from farm to fork. The program covers the main actors, critical decisions, and innovative technologies across production, post-harvest management, marketing, distribution, and retail. You'll also learn to design competitive business models and grasp financing and accounting concepts tailored to the agribusiness sector.",
    length: '75 hours',
    requirement: 'Laptop/tablet optional; course is mobile-friendly.',
    receives: 'Professional Certification',
  },
]

const UPSKILL_BAHAMAS_COURSES = {
  new: [
    { label: 'Building AI Agents for Beginners (Beginner Level) | By Davidson College', value: 'building ai agents for beginners' },
    { label: 'Agentic AI: Developing AI Agents (Advanced Level) | By IBM', value: 'agentic ai developing ai agents (advanced)' },
    { label: 'Personal Finance Professional Certificate | By Indiana University (Kelley School of Business)', value: 'personal finance professional certificate' },
    { label: 'Visual Design | By Skillcrush', value: 'visual design' },
    { label: 'UX Design | By Skillcrush', value: 'ux design' },
    { label: 'Finance & Investment Foundations | By Oxford University', value: 'finance & investment foundations' },
    { label: 'Sustainability Foundations | By Oxford University', value: 'sustainability foundations' },
    // { label: 'Small Business Management Certificate | By Louisiana State University', value: 'small business management certificate' },
    { label: 'Entrepreneurship Foundations | By Oxford University', value: 'entrepreneurship foundations' },
    { label: 'Customer Service and Professional Communications | By Turiscool', value: 'customer service and professional communications' },
    { label: 'Leadership Foundations | By Oxford University', value: 'leadership foundations' },
    { label: 'Introduction to Port Management and Terminal Operations (Beginner Level) | By Lloyd\'s Maritime Institute', value: 'introduction to port management and terminal operations (beginner)' },
    { label: 'Warehouse Operations Management (Intermediate Level) | By STC Next', value: 'warehouse operations management (intermediate)' },
    { label: 'Port Operations and Maintenance Training (Intermediate/Advanced Level) | By ASCE', value: 'port operations and maintenance training (intermediate/advanced)' },

  ],
  tech: [
    { label: '(NEW) Building AI Agents for Beginners (Beginner Level) | By Davidson College', value: 'building ai agents for beginners' },
    { label: '(NEW) Agentic AI: Developing AI Agents (Advanced Level) | By IBM', value: 'agentic ai developing ai agents (advanced)' },
    { label: 'No-Code & Automatization | By 4Geeks', value: 'no code automatization' },
    { label: 'Foundations of AI & Digital Skills | By Beyond Code Collective', value: 'foundations of ai digital skills' },
    { label: 'Artificial Intelligence for Everyone | By Ply', value: 'artificial intelligence for everyone' },
    { label: 'Data Literacy | By Le Wagon', value: 'data literacy' },
    { label: 'Power BI and SQL for Data Analysts | By SkillNest', value: 'power bi sql for data analysts' },
    { label: 'Artificial Intelligence in Professional Settings: Practical Applications | By 4Geeks', value: 'artificial intelligence in professional settings' },
    { label: 'Python for Data Analysts | By SkillNest', value: 'python for data analysts' },
    { label: 'Basic Web Development | By SkillNest', value: 'basic web development' },
    { label: 'Network Fundamentals | By 4Geeks', value: 'network fundamentals' },
    { label: 'Introduction to Python Programming | By VisionAid Training', value: 'introduction to python programming' },
  ],
  business: [
    { label: '(New) Personal Finance Professional Certificate | By Indiana University (Kelley School of Business)', value: 'personal finance professional certificate' },
    { label: '(New) Visual Design | By Skillcrush', value: 'visual design' },
    { label: '(New) UX Design | By Skillcrush', value: 'ux design' },
    // { label: '(New) Small Business Management Certificate | By Louisiana State University', value: 'small business management certificate' },
    { label: '(New) Finance & Investment Foundations | By Oxford University', value: 'finance & investment foundations' },
    { label: '(New) Sustainability Foundations | By Oxford University', value: 'sustainability foundations' },
    { label: 'Introduction to Investment Banking | By The New York Institute of Finance', value: 'introduction to investment banking' },
    { label: 'How to Maximize Chances of Quality Employment | By 4Geeks', value: 'how to maximize chances of quality employment' },
    { label: 'Business Communication | By Rochester Institute of Technology', value: 'business communication' },
    { label: 'Business Finance | By W Learning', value: 'business finance' },
    { label: 'Introduction to Corporate Finance | By Columbia University', value: 'introduction to corporate finance' },
    { label: 'How to Govern a Company | By The Association of Governance Risk & Compliance', value: 'how to govern a company' },
    { label: 'Marketing Fundamentals | By Babson College', value: 'marketing fundamentals' },
    { label: 'Digital Marketing, Online Advertising & Social Media | By University of Maryland', value: 'digital marketing online advertising social media' },
    { label: 'Business and Data Analysis Skills | By Fullbridge', value: 'business and data analysis skills' },
  ],
  entrepreneurship: [
    // { label: '(NEW) Small Business Management Certificate | By Louisiana State University', value: 'small business management certificate' },
    { label: '(NEW) Entrepreneurship Foundations | By Oxford University', value: 'entrepreneurship foundations' },
    { label: 'AI for Entrepreneurs | By LeWagon', value: 'ai for entrepreneurs' },
    { label: 'Entrepreneurial Leadership Toolbox | By Babson College', value: 'entrepreneurial leadership toolbox' },
    { label: 'Customer-Centric Marketing for Entrepreneurs | By Babson College', value: 'customer centric marketing for entrepreneurs' },
  ],
  'health wellness': [
    { label: 'Ultimate First Aid and CPR at Work | By Online First Aid', value: 'ultimate first aid and cpr at work' },
    { label: 'Nail Technician Course | By Elizabeth Sands', value: 'nail technician course' },
    { label: 'Ultimate First Aid: CPR and AED Course for Work, Home and Leisure | By Online First Aid', value: 'ultimate first aid cpr and aed course for work home and leisure' },
  ],
  hospitality: [
    { label: '(NEW) Customer Service and Professional Communications | By Turiscool', value: 'customer service and professional communications' },
    { label: 'Event Planning | By W Learning', value: 'event planning' },
    { label: 'Managing Sustainable Tourism Experiences | W Learning', value: 'managing sustainable tourism experiences' },
    { label: 'Housekeeping Management | By TurisCool', value: 'housekeeping management' },
    { label: 'Guest Experience Journey in Hospitality | By W Learning', value: 'guest experience journey in hospitality' },
    { label: 'Cruise Ship Hospitality Fundamentals | By W Learning', value: 'cruise ship hospitality fundamentals' },
    { label: 'Buffet Management: Keys to Service Optimization | By Turiscool', value: 'buffet management keys to service optimization' },
    { label: 'Front Desk Operations and Guest Services | By TurisCool', value: 'front desk operations and guest services' },
  ],
  'language communication': [
    { label: '(NEW) Leadership Foundations | By Oxford University', value: 'leadership foundations' },
    { label: 'The Art of Persuasive Writing and Public Speaking | By Harvard University', value: 'the art of persuasive writing and public speaking' },
    { label: 'English for Business: Pitching, Persuading and Promoting | By Arizona State University', value: 'english for business pitching persuading and promoting' },
    { label: 'Spanish Language Level 1 | By Rocket Languages', value: 'spanish language level 1' },
    { label: 'French Language Level 1 | By Rocket Languages', value: 'french language level 1' },
  ],
  teaching: [
    { label: 'AI for Educators | By SkillNest', value: 'ai for educators' },
    { label: 'Classroom Management for New Teachers | By W Learning', value: 'classroom management for new teachers' },
    { label: 'Teaching English as a Foreign Language (TEFL) | By Cudoo', value: 'teaching english as a foreign language (tefl)' },
    { label: 'AI and Special Education | By W Learning', value: 'ai and special education' },
  ],
  'skilled trades': [
    { label: '(NEW) Introduction to Port Management and Terminal Operations (Beginner Level) | By Lloyd\'s Maritime Institute', value: 'introduction to port management and terminal operations (beginner)' },
    { label: '(NEW) Warehouse Operations Management (Intermediate Level) | By STC Next', value: 'warehouse operations management (intermediate)' },
    { label: '(NEW) Port Operations and Maintenance Training (Intermediate/Advanced Level) | By ASCE', value: 'port operations and maintenance training (intermediate/advanced)' },
    { label: 'Caregiver Certification Course | By U.S. Career Institute', value: 'caregiver certification course' },
    { label: 'Construction Management | By University of Maryland', value: 'construction management' },
    { label: 'AutoCAD Training | By CAD Training Online', value: 'autocad training' },
    { label: 'Supply Chain Management Tools and Techniques | By International Supply Chain Education Alliance', value: 'supply chain management tools and techniques' },
    { label: 'Agribusiness Value Chains Program | By Agribusiness Academy', value: 'agribusiness value chains program' },
  ],
}

export { UPSKILL_BAHAMAS_COURSES, UPSKILL_BAHAMAS_COURSES_SUMMARY }
